import { useUserContext } from '../contexts/UserContext'
import { Column } from '../common/pure/FlexContainer'
import Heading from '../common/pure/Heading'
import { NavigationTextLink } from './NavigationLink'
import { isDevEnv } from '../../tools/env'
import t from '../../tools/t'
import { useBoltContext } from '../contexts/BoltContext'

export default function OrganizationMenu() {
    const { selectedOrganization } = useUserContext()
    const { manufacturedBolts, unassignedBolts } = useBoltContext()

    const organizationName = selectedOrganization?.name ?? ''

    return (
        <Column wide gap={0.25} className="sub-menu">
            <Heading size={3}>{organizationName}</Heading>
            <NavigationTextLink
                icon="address-book"
                text={t('manage_organization_x', organizationName)}
                to={selectedOrganization?.profileLink}
            />
            <NavigationTextLink icon="user" text={t('manage_users')} to="/users" />
            <NavigationTextLink icon="wave-pulse" text={t('sensors_list')} to="/sensors" />
            <NavigationTextLink icon="tablet" text={t('devices_list')} to="/devices" />
            <NavigationTextLink icon="file" text="Workfiles" to="/workfiles" />
            <NavigationTextLink
                icon="pen-to-square"
                text={t('calibration_rods_list')}
                to="/calibration-rods"
            />
            {manufacturedBolts.hasAnyPage && (
                <NavigationTextLink
                    icon="list"
                    text={t('manufactured_bolts_list')}
                    to="/manufactured"
                />
            )}
            {unassignedBolts.hasAnyPage && isDevEnv() && (
                <NavigationTextLink
                    icon="question"
                    text={t('unassigned_bolts_list')}
                    to="/unassigned"
                />
            )}
            <NavigationTextLink
                icon="wrench"
                text={t('service_window_title')}
                to="/service-window"
            />
        </Column>
    )
}
